import { render, staticRenderFns } from "./welcome.component.vue?vue&type=template&id=a18585ec&scoped=true"
import script from "./welcome.component.vue?vue&type=script&lang=js"
export * from "./welcome.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18585ec",
  null
  
)

export default component.exports